export default __webpack_public_path__ + "static/media/home-icon.d6f59f05.svg";